import {Dimensions, StyleSheet} from 'react-native';

import {getWidth} from '../../../../utils/common';
import {scaleFonts} from '@buncha/appStyles/style/font';

const {width} = Dimensions.get('screen');

const SPACING = 5;
const ITEM_LENGTH = width * 0.4; // Item is a square. Therefore, its height and width are of the same length.
const BORDER_RADIUS = 20;

export const styles = StyleSheet.create({
  marBot: {marginBottom: 50},
  container: {backgroundColor: 'white'},
  child: {
    width: getWidth(width - 200),
    justifyContent: 'center',
    marginRight: 40,
    height: 450,
  },
  itemContent: {
    marginRight: 5,
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: BORDER_RADIUS + SPACING * 2,
    zIndex: 2,
    width: getWidth(width),
  },
  itemImage: {
    width: Dimensions.get('screen').width - scaleFonts(57),
    height: ITEM_LENGTH,
    borderRadius: BORDER_RADIUS,
  },
  imageCaptionContainer: {
    width: getWidth(width),
    flexDirection: 'row',
    justifyContent: 'center',
  },
  pillBody: {
    flexDirection: 'row',
    position: 'absolute',
    right: 0,
    top: 40,
    zIndex: 1,
  },
  bodyContainer: {
    paddingVertical: 15,
    paddingHorizontal: 10,
    marginHorizontal: 15,
    borderRadius: 14,
    marginBottom: 10,
  },
  subBodyContainer: {
    marginTop: 10,
  },
  contentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  childContainer: {marginHorizontal: 15},
  iconBox: {marginRight: 5},
  buttonStyle: {marginBottom: 10},
  divider: {marginVertical: 5},
  textStyle: {
    textAlign: 'left',
    marginTop: 10,
  },
  buyerDetailContainer: {
    borderRadius: 14,
    padding: 10,
  },
  adjOOSDivider: {marginVertical: 15},
});
